import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row g-4" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { class: "row g-4 mb-4" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Stats = _resolveComponent("Stats")!
  const _component_RoomsAvailabilityChart = _resolveComponent("RoomsAvailabilityChart")!
  const _component_GuestActivityChart = _resolveComponent("GuestActivityChart")!
  const _component_UpcomingVIPReservations = _resolveComponent("UpcomingVIPReservations")!
  const _component_RecentBookings = _resolveComponent("RecentBookings")!
  const _component_PopularRooms = _resolveComponent("PopularRooms")!
  const _component_CustomerReviews = _resolveComponent("CustomerReviews")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Stats),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RoomsAvailabilityChart)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_GuestActivityChart)
          ])
        ]),
        _createVNode(_component_UpcomingVIPReservations)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_RecentBookings)
      ])
    ]),
    _createVNode(_component_PopularRooms),
    _createVNode(_component_CustomerReviews)
  ]))
}